import React, { useContext, useEffect, useState } from 'react'
import { ZendeskContext } from '../../store/zendesk-context'
import Spinner from '../UI/Spinner'
import { zendeskHistoryAPI } from '../../services/api/zendesk-history'
import { getCookie } from '../../utils/common'
import styles from './TicketList.module.css'
import TicketItems from './TicketItems'
import searchIcon from '../../assets/images/search-icon.svg';

const TicketList = () => {

	const zendeskCtx = useContext(ZendeskContext)
	const [error, setError] = useState('')
	const [searchedFromListID, setSearchedFromListID] = useState('')

	useEffect(() => {
	  getHistory()
	}, [])

	const getHistory = () => {
        const tenantSlug = getCookie('current_tenant')
        zendeskHistoryAPI(tenantSlug).getAll?.()
            .then((response) => {
				zendeskCtx.updateHistoryLoadingStatus(false)
				zendeskCtx.updateHistoryData(response)
                // setData(data)
                // setIsLoading(false)
            })
            .catch((err: any) => {
                if (err.response) {
                    console.log(err.response)
                } else if (err.request) {
                    console.log(err.request)
                } else {
                    console.log(err)
                }
            })
    }
	

	return (		
		<div className={styles.ticketListContainer}>
			{
				zendeskCtx?.isHistoryLoading && !zendeskCtx?.historyData?.length  &&
					<div className="d-flex justify-content-center my-5 p-2">
						<Spinner size="md" />
					</div>
			}
			{
				zendeskCtx?.historyData?.length > 0 ?
					<div className={styles.ticketContainer}>
						<div className={`${styles.header} d-flex justify-content-between align-items-center`}>
							<div>
								<h6 className='text-uppercase'>Tickets</h6>
								<p>List of tickets searched for the conversations</p>
							</div>
							<div className={`d-flex align-items-center me-2 ${styles.search}`}>
                                <input placeholder='Search ticket id' id="search-bar" type="text" value={searchedFromListID} onChange={(e) => setSearchedFromListID(e?.target?.value)} />
                                <img src={searchIcon} />
                            </div>
						</div>
						<div className={styles.ticketTable}>
							<div className={styles.ticketTableHeader}>
								<h6>Ticket Title</h6>
								<h6>Ticket ID</h6>
								<h6 className='text-center'>Conversations</h6>
								<h6>Recent Conversation</h6>
								<h6></h6>
							</div>
							<TicketItems 
								searchedFromListID={searchedFromListID}
							/>
						</div>
					</div> :
					(
						!zendeskCtx?.isHistoryLoading ?
							<h3 className="d-flex justify-content-center p-5">No Tickets Found!</h3> :
							null
					)
			}
			{
				!zendeskCtx?.isHistoryLoading && !zendeskCtx?.historyData && !zendeskCtx?.historyData.length && 
					<div>{ error }</div>
			}
		</div>
 	)
}

export default TicketList